export const columnasNomina = [
  {
    key: 'fecha_de_carga',
    label: 'Fecha de carga',
    sorted: true,
    fixed: false,
    type: 'string',
    hidden: false,
    // cellClassName: 'w-[200px]',
  },
  {
    key: 'periodo',
    label: 'Período fiscal',
    sorted: true,
    fixed: false,
    type: 'string',
    hidden: false,
    // cellClassName: 'w-[100px]',
    // notTextEllipsis: true,
  },
  {
    key: 'empleados',
    label: 'Cápitas',
    sorted: true,
    fixed: false,
    type: 'number',
    hidden: false,
    // cellClassName: 'w-[100px]',
  },
  {
    key: 'total_masa_salarial',
    label: 'Masa salarial',
    sorted: true,
    fixed: false,
    type: 'number',
    hidden: false,
  },
  {
    key: 'salario_promedio',
    label: 'Salario promedio',
    sorted: true,
    fixed: false,
    type: 'number',
    hidden: false,
    // cellClassName: 'w-[200px]',
  },
  {
    key: 'devengado_cuota',
    label: 'Cuota devengada calculada',
    sorted: false,
    fixed: false,
    type: 'number',
    hidden: false,
    // cellClassName: 'w-[250px]',
  },
  {
    key: 'total_ffep',
    label: 'Total FFEP',
    sorted: false,
    fixed: false,
    type: 'number',
    hidden: false,
  },
  {
    key: 'total_a_pagar',
    label: 'Total a pagar',
    sorted: false,
    fixed: false,
    type: 'number',
    hidden: false,
    // cellClassName: 'w-[200px]',
  },
  {
    key: 'estado',
    label: 'Estado',
    sorted: false,
    fixed: false,
    type: 'component',
    hidden: false,
    cellClassName: 'w-[100px]',
  },
  {
    key: 'acciones',
    label: '',
    sorted: false,
    fixed: false,
    type: 'component',
    hidden: false,
  },
]
